import styled from 'styled-components';
import React, { Component } from 'react';
import { enableUniqueIds } from 'react-html-id';
import { OverlayTrigger } from 'react-bootstrap';
import { HelpIcon } from 'components/atoms/HelpIcon';

const HelpIconPadding = styled(HelpIcon)`
    padding-top: 2px;
`;

const CheckBoxWrapper = styled.div`
    display: inline-flex;
    position: relative;
    margin: 0 0 10px;
    font-size: 14px;
    line-height: 24px;

    *, *:before, *:after {
        box-sizing: inherit;
    }

    input {
        position: absolute;
        top: 4px;
        left: 0;
        width: 36px;
        height: 20px;
        opacity: 0;
        z-index: 0;
    }

    label {
        display: block;
        padding: 0 0 0 24px;
        cursor: pointer;
        font-weight: 200;
        color: #000;

        &:before {
            content: '';
            position: absolute;
            top: 4px;
            left: 0;
            width: 16px;
            height: 16px;
            background-color: transparent;
            border: 1px solid #000;
            z-index: 1;
            transition: border-color 0.28s cubic-bezier(.4, 0, .2, 1);
        }

        &:after {
            content: '';
            position: absolute;
            top: 8px;
            left: 4px;
            width: 8px;
            height: 8px;
            background-color: ${props => props.theme.colors.primary};
            z-index: 2;
            transform: scale(0, 0);
            transition: transform 0.28s cubic-bezier(.4, 0, .2, 1);
        }
    }

    input:checked + label {
        &:before {
            border-color: ${props => props.theme.colors.primary};
        }

        &:after {
            transform: scale(1, 1);
        }
    }
`;

class CheckBoxSelect extends Component {
    constructor() {
        super();

        enableUniqueIds(this);
    }

    render() {
        return (
            <CheckBoxWrapper className="checkbox">
                <input {...this.props.input} id={ this.getUniqueId('channel') } type="checkbox" />
                <label htmlFor={this.getUniqueId('channel')}>{this.props.label}</label>
                {this.props.overlay ? (
                    <OverlayTrigger trigger="click" placement="right" overlay={this.props.overlay}>
                        <HelpIconPadding />
                    </OverlayTrigger>
                ) : null}
            </CheckBoxWrapper>
        );
    }
}

export default CheckBoxSelect;



// WEBPACK FOOTER //
// ./src/components/atoms/form/CheckBoxSelect.js